module.exports = __webpack_public_path__ + "static/img/tsl3.865da6d9.jpg";